"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var revert_error_1 = require("../../revert_error");
var MismanagedMemoryError = /** @class */ (function (_super) {
    __extends(MismanagedMemoryError, _super);
    function MismanagedMemoryError(freeMemPtr, addressArrayEndPtr) {
        return _super.call(this, 'MismanagedMemoryError', 'MismanagedMemoryError(uint256 freeMemPtr, uint256 addressArrayEndPtr)', {
            freeMemPtr: freeMemPtr,
            addressArrayEndPtr: addressArrayEndPtr,
        }) || this;
    }
    return MismanagedMemoryError;
}(revert_error_1.RevertError));
exports.MismanagedMemoryError = MismanagedMemoryError;
// Register the MismanagedMemoryError type
revert_error_1.RevertError.registerType(MismanagedMemoryError);
//# sourceMappingURL=lib_address_array_revert_errors.js.map